// src/utils/NotifyingLocalStorage.ts
import {LocalStorage, SIWXStorage, SIWXSession} from "@reown/appkit-siwx";
import {CaipNetworkId} from "@reown/appkit";

export const STORAGE_EVENT = "siwx-storage";

export class NotifyingLocalStorage implements SIWXStorage {
  private key: string

  constructor(params: LocalStorage.ConstructorParams) {
    this.key = params.key
  }

  add(session: SIWXSession): Promise<void> {
    const sessions = this.getSessions()
    sessions.push(session)
    this.setSessions(sessions)

    // console.log("add", session)

    this.notify("add");
    return Promise.resolve()
  }

  set(sessions: SIWXSession[]): Promise<void> {
    this.setSessions(sessions)

    // console.log("set", sessions)
    this.notify("set");
    return Promise.resolve()
  }

  get(chainId: CaipNetworkId, address: string): Promise<SIWXSession[]> {
    const allSessions = this.getSessions()
    // console.log("all sassion", allSessions, chainId, address)

    const validSessions = allSessions.filter(session => {
      const isSameChain = session.data.chainId === chainId
      const isSameAddress = session.data.accountAddress === address

      const startsAt = session.data.notBefore || session.data.issuedAt
      if (startsAt && Date.parse(startsAt) > Date.now()) {
        return false
      }

      const endsAt = session.data.expirationTime
      if (endsAt && Date.now() > Date.parse(endsAt)) {
        return false
      }

      return isSameChain && isSameAddress
    })

    return Promise.resolve(validSessions)
  }

  delete(chainId: string, address: string): Promise<void> {
    // console.log("before delete", this.getSessions())
    const sessions = this.getSessions().filter(
      session => session.data.chainId !== chainId && session.data.accountAddress !== address
    )
    // console.log("after delete", sessions)
    this.setSessions(sessions)


    this.notify("delete");
    return Promise.resolve()
  }

  private getSessions(): LocalStorage.Sessions {
    if (typeof localStorage === 'undefined') {
      throw new Error('localStorage not available')
    }

    const stringItem = localStorage.getItem(this.key)

    return stringItem ? JSON.parse(stringItem) as LocalStorage.Sessions : []
  }

  private setSessions(sessions: LocalStorage.Sessions): void {
    localStorage.setItem(this.key, JSON.stringify(sessions))
  }

  private notify(type: "add" | "delete" | "set") {
    window.dispatchEvent(new CustomEvent(STORAGE_EVENT, {detail: {type}}));
  }




}

export const StorageInstance = new NotifyingLocalStorage({key: "siwx-sessions"})